/** Normalize webpack asset imports (string or { default: string }). */
export function assetUrl(asset) {
  if (!asset) return '';
  if (typeof asset === 'string') return asset;
  if (typeof asset.default === 'string') return asset.default;
  return '';
}
